import { render, staticRenderFns } from "./PayAboutOrder.vue?vue&type=template&id=e63ebbcc&scoped=true&"
import script from "./PayAboutOrder.vue?vue&type=script&lang=js&"
export * from "./PayAboutOrder.vue?vue&type=script&lang=js&"
import style0 from "./PayAboutOrder.vue?vue&type=style&index=0&id=e63ebbcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63ebbcc",
  null
  
)

export default component.exports